import { PositionableTextDocument } from '@src/lib/PositionableTextDocument';
import type { TRect } from '../../types/misc';

const OVERFLOW_LEEWAY = 0.001;

interface TLocation {
  top: number;
  left: number;
  height: number;
  width: number;
}

export function calculateOverflowContainerLocation(
  baseLocation: { top: number; right: number },
  containerLocationInDom: TRect,
  contentLocationInDom: TRect
): TLocation {
  const top =
    containerLocationInDom.y + contentLocationInDom.y + baseLocation.top;
  const height = 18;
  const width = 18;
  const left =
    containerLocationInDom.x +
    contentLocationInDom.x +
    contentLocationInDom.width -
    baseLocation.right -
    width;

  return { top, left, height, width };
}

export function calculateTextOverflows(
  content: PositionableTextDocument,
  contentAreaHeight: number,
  contentAreaWidth: number
): boolean {
  const ast = content.toAst();

  const lowestWordLocation = ast.p.reduce(function (lowest, current) {
    return Math.max(lowest, current.y);
  }, 0);

  const rightmostWordLocation = ast.p.reduce(function (rightmost, current) {
    return Math.max(rightmost, current.x + current.w);
  }, 0);

  const contentLocationLowerBound = contentAreaHeight;
  const contentLocationRightBound = contentAreaWidth;

  const isTooTall =
    lowestWordLocation > contentLocationLowerBound + OVERFLOW_LEEWAY;
  const isTooWide =
    rightmostWordLocation > contentLocationRightBound + OVERFLOW_LEEWAY;

  return isTooTall || isTooWide;
}
